import { render, staticRenderFns } from "./GoogleAuthLogin.vue?vue&type=template&id=4bb12311&scoped=true&"
import script from "./GoogleAuthLogin.vue?vue&type=script&lang=js&"
export * from "./GoogleAuthLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb12311",
  null
  
)

export default component.exports